import { memo } from 'react';

import { FavoriteButton } from '@/components/FavoriteButton';
import type { MenuItem } from '@/consts/navigation';
import { useActiveRoute } from '@/features/navigation/hooks/useActiveRoute';
import { cn } from '@/utils/cn';

import { NavLink } from './NavLink';

interface NavMenuItemRowProps {
  childItem: MenuItem;
  isPopover: boolean;
  isUtilitySection?: boolean;
}

export const NavMenuItemRow = memo<NavMenuItemRowProps>(function NavMenuItemRow({
  childItem,
  isPopover,
  isUtilitySection
}) {
  const { isActive } = useActiveRoute(childItem.to);
  const isEmptyState = !childItem.to;

  return (
    <li key={childItem.text} role="none">
      <div
        className={cn(
          'relative flex items-center justify-between rounded pr-[3px] transition-colors',
          isPopover && 'text-typography/85 hover:text-typography h-10 gap-2.5 px-4',
          isActive ? 'bg-primary-900' : isEmptyState ? '' : 'hover:bg-secondary-500'
        )}
        role="menuitem"
      >
        <NavLink
          to={childItem.to ?? undefined}
          text={childItem.text}
          isUtilitySection={isUtilitySection}
          className={cn(
            'text-left',
            isPopover && 'flex-1 overflow-hidden pl-0 text-sm text-ellipsis whitespace-nowrap',
            isActive && '!text-typography',
            isEmptyState && 'text-typography/50 cursor-default italic'
          )}
        />

        {!isEmptyState && (
          <FavoriteButton code={childItem.code} itemText={childItem.text} isActive={isActive} isPopover={isPopover} />
        )}
      </div>
    </li>
  );
});
